
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 2a1 1 0 10-2 0v4a1 1 0 102 0V2zm0 16a1 1 0 10-2 0v4a1 1 0 102 0v-4zM4.223 4.223a1 1 0 011.414 0l2.83 2.83a1 1 0 11-1.414 1.414l-2.83-2.83a1 1 0 010-1.414zm12.724 11.31a1 1 0 00-1.414 1.414l2.83 2.83a1 1 0 001.414-1.414l-2.83-2.83zM1 12a1 1 0 011-1h4a1 1 0 110 2H2a1 1 0 01-1-1zm17-1a1 1 0 100 2h4a1 1 0 100-2h-4zm-9.533 4.533a1 1 0 010 1.414l-2.83 2.83a1 1 0 01-1.414-1.414l2.83-2.83a1 1 0 011.414 0zm11.31-9.896a1 1 0 10-1.414-1.414l-2.83 2.83a1 1 0 001.414 1.414l2.83-2.83z","fill":"#04080E"}})])
          )
        }
      }
    